/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getPostThread.defs.js'
export * as $defs from './getPostThread.defs.js'
